import { ReservationForm } from '@/types';
import { useForm } from '@inertiajs/react';

interface Params {
    customer: App.Data.CustomerData | null;
    reservableType: 'room' | 'table';
    reservableId: string | number;
}

export function useReservationForm({
    customer,
    reservableType,
    reservableId,
}: Params) {
    return useForm<ReservationForm>({
        name: customer?.name ?? '',
        phone: customer?.phone ?? '',
        date: '',
        start_time: '',
        end_time: '',
        guests: 1,
        reservable_type: reservableType,
        reservable_id: reservableId?.toString() ?? '',
    });
}
